module.exports = __webpack_public_path__ + "img/download-icon.75c810f8.png";